/* global System */
// register component(s) with react habitat

export default {
  PressGrid: () => System.import('./index'),
}
